<template>
  <div
    class="main-container"
    :style="{ paddingTop: os.isPhoneX && !isOutSide ? '24px' : '' }"
  >
    <div
      class="top-bar"
      :style="{ height: marginTop }"
      v-show="!isOutSide"
    ></div>
    <div
      class="header-wrapper"
      :style="{ top: marginTop, backgroundPosition: 'center -' + marginTop }"
      v-show="!isOutSide"
    >
      <div class="header-relative" ref="mainHeader">
        <header class="header" :class="isTouchToHeader ? 'active' : ''">
          <i class="iconfont icon-back" @click="jumpBack"></i>
          <p class="title">{{ reporterInfo.reporterName }}</p>
          <div class="more-wrapper">
            <i class="icon icon-point" @click="handleShare"></i>
            <transition name="drop-top">
              <button 
                class="btn btn-bg" 
                :class="hasSubscribe ? 'bg-gray' : ''" 
                v-show="isTouchToHeader && !isReporter" 
                @click="subscribeReporter"
              >
                {{hasSubscribe ? '已订阅' : '+订阅'}}
              </button>
            </transition>
          </div>
        </header>
      </div>
    </div>
    <!-- 背景图片，为了能使背景图片刚好就是记者信息的高度 -->
    <div class="bg-wrapper"></div>
    <nf-page
      @scroll="scroll"
      :listenScroll="scrollOptions.listenScroll"
      :probeType="scrollOptions.probeType"
      :pullUpLoad="scrollOptions.pullUpLoad"
      @scrollToEnd="onPullUp"
      :pullup="scrollOptions.pullup"
      :isPullUpLoad="scrollOptions.isPullUpLoad"
      :isNoMoreData="scrollOptions.isNoMoreData"
      :eventPassthrough="scrollOptions.eventPassthrough"
      ref="scroll"
    >
      <div v-if="dataLoaded" class="info-wrapper" :style="{ paddingTop: InfoWrapperPaddingTop }">
        <div class="reporter-info-wrap" ref="reporterInfo">
          <div class="reporter-name" ref="reporterName">
            <p class="name">{{ reporterInfo.reporterName }}</p>
            <div class="btn-wrapper">
              <div
                class="btn btn-bg btn-subscribe"
                :class="hasSubscribe ? 'bg-gray' : ''"
                @click="subscribeReporter"
              >
                <span>{{ hasSubscribe ? "已订阅" : "+订阅" }}</span>
              </div>
              <!-- <button class="btn btn-opacity"
                      @click="jumpToPrivateLetter"
              v-show="userInfo.userUuid != reporterInfo.reporterUserUuid">私信</button>-->
              <div class="btn btn-opacity btn-private" @click="jumpH5PrivateLetter">
                <span>私信</span>
              </div>
            </div>
          </div>
          <div class="reporter-intruduce">
            <div class="item">
              <span class="title">认&nbsp;&nbsp;证：</span>
              <p class="info">{{ reporterInfo.reporterAuth }}</p>
            </div>
            <div class="item">
              <span class="title">简&nbsp;&nbsp;介：</span>
              <div class="des-wrapper" ref="desWrapper">
                <p class="info no-limit" ref="desc">
                  <span> {{ reporterInfo.reporterDescribe }} </span>
                </p>
              </div>
            </div>
            <div
              class="item center"
              v-if="
                (insideVersion >= 510 || insideVersion == false) &&
                reporterInfo.reporterOperators.length > 0
              "
            >
              <span class="title">运&nbsp;&nbsp;营：</span>
              <div class="operate-info">
                <div
                  class="left"
                  @click="
                    shareNFNum(reporterInfo.reporterOperators[0].columnId)
                  "
                >
                  <img
                    :src="
                      reporterInfo.reporterOperators[0].columnIcon ||
                      require('./images/default_header.png')
                    "
                    alt
                  />
                  <p class="name">
                    {{ reporterInfo.reporterOperators[0].columnName }}
                  </p>
                </div>
                <div
                  class="more"
                  v-if="reporterInfo.reporterOperators.length > 1"
                  @click="
                    $router.push({
                      name: 'operateAccount',
                      query: { reporterUuid: reporterInfo.reporterUuid },
                    })
                  "
                >
                  <span>更多</span>
                  <div class="icon_next_grey"></div>
                </div>
              </div>
            </div>
            <div class="item">
              <span class="title">IP属地：</span>
              <p class="info">{{ reporterInfo.ipLocation }}</p>
            </div>
            <div class="reporter-header-wrapper">
              <div class="reporter-header">
                <img
                  :src="reporterInfo.reporterPortraitUrl"
                  :preview="1"
                  class="img-response"
                />
              </div>
              <div class="icon-v"></div>
            </div>
          </div>
        </div>
        <div class="middle-slit"></div>
        <ul class="reporter-works-list">
          <li
            class="reporter-works-item"
            v-for="(item, index) in articleInfo"
            :key="index"
            @click="toJumpDetail(item)"
          >
            <!-- 我应该直接把整个对象传进去的 -->
            <nfItem :itemInfo="item"></nfItem>
          </li>
        </ul>
      </div>
    </nf-page>
    <nf-toast
      v-model="toastOptions.showTost"
      :toastTxt="toastOptions.toastTxt"
    ></nf-toast>
    <nf-loading :showLoading="showLoading"></nf-loading>
    <nf-update-tips
      @exit="jumpBack"
      :showUpdateTips="showUpdateTips"
    ></nf-update-tips>
  </div>
</template>
<script>
import nfItem from "@components/extends/nfItem";
import nfUpdateTips from "@components/extends/nfUpdateTips";
import utils from "@common/utils";
import http from "@common/js/tools/http.js";
import config from "../../../config";
import getParamsFromUrl from "../../common/utils/getParamsFromUrl";
let env = process.env.VUE_APP_RUN_ENV;
const NET_ERR_MSG = "网络连接超时，请稍后重试";
const SUB_MSG = "订阅成功，可在订阅频道查看更新";
const CANCEL_SUB_MSG = "取消订阅成功";
export default {
  name: "mainPage",
  data() {
    return {
      scrollOptions: {
        // 是否坚挺滚动事件
        listenScroll: true,
        probeType: 3,
        // 显示
        pullUpLoad: true,
        pullup: true,
        // 显示加载动画还是显示没有更多, true - 加载动画， false - 没有更多
        isPullUpLoad: true,
        isNoMoreData: false
        // 端外禁止一切body的touchmove
        // eventPassthrough: utils.getParamsFromUrl().isOutside ? '' : 'horizontal'
      },
      // 系统信息
      os: {
        ios: false,
        pc: false,
        android: false,
        isWx: false,
        isPhoneX: false,
        isLargeThan375: false,
      },
      // 记者的名字的元素顶部到页面顶部距离
      reporterNameDomToTop: 0,
      // 导航栏底部到页面顶部距离
      headerBottomToTop: 0,
      // 页面滚动多少后导航栏样式改变的临界值
      topHeaderDis: 0,
      // 导航条过度时间
      transitionTime: 0,
      // 内容区是否触碰到导航条
      isTouchToHeader: false,
      // 显示toast
      toastOptions: {
        showTost: false,
        toastTxt: "",
      },
      // 记者信息
      reporterInfo: {
        ipLocation: "",
        // 记者uuid
        reporterUuid: "",
        reporterUserUuid: "",
        reporterName: "",
        reporterPhone: "",
        reporterUnit: "",
        reporterDepartment: "",
        reporterPortraitUrl: require("./images/default_header.png"),
        reporterDescribe: "",
        reporterAuth: "",
        reporterOperators: [],
      },
      // 是否已订阅改记者
      hasSubscribe: false,
      // 作品列表
      articleInfo: [],
      // 请求列表参数
      listReqOptions: {
        pageSize: 10,
        pageNo: 1,
      },
      showLoading: false,
      InfoWrapperPaddingTop: 0,
      // 用户信息
      userInfo: {
        userUuid: "",
        phone: "",
        reporterUuid: "",
      },
      // 是否是记者，从url获取isReporter, 如果有该字段且为1则代表为记者
      isReporter: false,
      // 是否端外
      isOutSide: false,
      // 是否已经初始化微信分享
      isInitWxShare: false,
      showUpdateTips: false,
      // 是否显示完整简介
      showAllDes: false,
      // 是否显示展开
      showDeloy: false,
      // 是否显示简介的第二行
      showDescLine2: false,
      // 端内版本号
      insideVersion: null,
      userUuid: "", //微信授权拿到的登陆id
      dataLoaded: false
    };
  },
  components: {
    nfItem,
    nfUpdateTips,
  },
  methods: {
    // 用于动态改变导航条样式
    scroll(pos) {
      // 没有加载数据不触发
      if (this.articleInfo.length < 1) return;
      let disY = -parseInt(pos.y);
      let isTouchToHeader = disY > this.topHeaderDis;
      if (isTouchToHeader) {
        this.isTouchToHeader = true;
      } else {
        this.isTouchToHeader = false;
      }
    },
    // 获取导航条的高度+pageY
    getHeaderBottomPageY() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          let headerDom = this.$refs.mainHeader;
          let offsetTop = utils.getDomOffsetHeight(headerDom);
          let clientH = headerDom.offsetHeight;
          // 导航栏底部到页面顶部距离
          this.headerBottomToTop = parseInt(clientH) + parseInt(offsetTop);
          resolve(this.headerBottomToTop);
        });
      });
    },
    // 获取系统信息
    getSystemInfo() {
      this.os = Object.assign(this.os, utils.getSystemInfo());
    },
    // 获取记者名字底部到页面顶部距离
    getReporterDomToTop() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          let reportNameDom = this.$refs.reporterInfo;
          let clientH = this.$refs.reporterName.offsetHeight;
          // iphoneX偏移量
          let dis = this.os.isPhoneX ? 24 : 0;
          this.reporterNameDomToTop =
            parseInt(reportNameDom.offsetTop) + parseInt(clientH) + dis;
          resolve(this.reporterNameDomToTop);
        });
      });
    },
    // 获取页面滚动改变导航栏样式临界值
    getTopHeaderDis() {
      this.topHeaderDis = this.reporterNameDomToTop - this.headerBottomToTop;
    },
    async initData() {
      await this.getHeaderBottomPageY();
      await this.getReporterDomToTop();
      this.getTopHeaderDis();
      this.transitionTime = 0.3;
    },
    // 从url获取记者名称
    getReporterNameFromUrl() {
      let params = utils.getParamsFromUrl();
      this.reporterInfo.reporterUuid = params.reporterUuid || "";
      this.reporterInfo.reporterUuid &&
        (this.reporterInfo.reporterUuid = parseInt(
          this.reporterInfo.reporterUuid
        ));
      this.isReporter = params.isReporter == 1 ? true : false;
      this.reporterInfo.reporterUserUuid = params.reporterUserUuid || "";
    },
    // toast提示
    showToast(msg = "") {
      this.toastOptions.toastTxt = msg;
      this.toastOptions.showTost = true;
    },
    // 上拉加载
    onPullUp() {
      if (this.scrollOptions.isNoMoreData || this.articleInfo.length === 0)
        return;
      this.listReqOptions.pageNo++;
      this.getReporterInfoList();
    },
    // 结束上拉加载
    finishPullUpLoad() {
      this.$nextTick(() => {
        this.$refs.scroll.finishPullUpLoad();
      });
    },
    // 刷新scroll
    refreshScroll() {
      this.$refs.scroll.refresh();
    },
    // 根据记者id获取记者作品集
    // 获取记者信息
    getReporterInfoList(showLoading) {
      let url = `nanfang_if/reporter/list?reporterUuid=${this.reporterInfo.reporterUuid}&pageSize=${this.listReqOptions.pageSize}&pageNo=${this.listReqOptions.pageNo}&origin=1`;
      let pageLoadingDom = document.getElementById("page-loading");
      if (!pageLoadingDom && showLoading) {
        this.showLoading = true;
      }
      if (!this.reporterInfo.reporterUuid || this.reporterInfo.reporterUuid == '0') {
        window.location.href = process.env.VUE_APP_404_PAPE
        return
      }
      http
        .get(url, {})
        .then((res) => {
          if (pageLoadingDom) {
            pageLoadingDom.parentNode.removeChild(pageLoadingDom);
          }
          showLoading && (this.showLoading = false);
          this.dataLoaded = true
          if (res.data && res.code === 200) {
            if(!res.data.reportInfo || !res.data.reportInfo.reporterUuid){
              window.location.href = process.env.VUE_APP_404_PAPE
              return
            }
            this.resolveReporterInfo(res.data.reportInfo);
            this.resolveListData(res.data.reportInfo);
            // 初始化微信二次分享会
            this.isOutSide && !this.isInitWxShare && this.initWxShare();
          } else {
            this.showToast(res.msg);
          }
          this.initData();
        })
        .catch((err) => {
          if (pageLoadingDom) {
            pageLoadingDom.parentNode.removeChild(pageLoadingDom);
          }
          showLoading && (this.showLoading = false);
          window.console.warn(err);
          this.showToast(NET_ERR_MSG);
        });
    },
    // 处理返回的记者作品列表数据
    resolveListData(res) {
      let default_img = require("./images/bg_default.png");
      res.articleInfo.forEach((item) => {
        let imgList = [];
        for (let i = 0; i < 3; i++) {
          imgList.push(item[`pic${i}`] || default_img);
        }
        if (imgList.length < 1) {
          imgList.push(default_img);
        }
        item.imgList = imgList;
      });
      if (this.listReqOptions.pageNo === 1) {
        this.articleInfo = res.articleInfo;
        let timer = window.setTimeout(() => {
          this.refreshScroll();
          window.clearTimeout(timer);
        }, 20);
      } else {
        this.articleInfo = this.articleInfo.concat(res.articleInfo);
        let timer = window.setTimeout(() => {
          this.finishPullUpLoad();
          window.clearTimeout(timer);
        }, 20);
      }
      // 因为文章数据有脏数据，所以有可能出现pageSize跟实际返回的数量不一致，现在没有更多数据的逻辑是，当下一页返回0条的时候才没有更多数据
      if (Array.isArray(res.articleInfo) && res.articleInfo.length < 1) {
        this.showNoMoreData();
      }
    },
    // 处理返回的记者信息
    resolveReporterInfo(res) {
      Object.keys(this.reporterInfo).forEach((key) => {
        if (this.reporterInfo[key].length === 0) {
          this.reporterInfo[key] = res[key] || "";
        }
      });
      if (res.reporterPortraitUrl) {
        this.reporterInfo.reporterPortraitUrl = res.reporterPortraitUrl;
      }
      document.title = this.reporterInfo.reporterName + "作品集-南方Plus";
      // 判断是否需要显示展开按钮
      this.needShowDeloy();
      this.refreshScroll();
    },
    // 显示没有更多数据
    showNoMoreData() {
      this.$nextTick(() => {
        this.scrollOptions.isPullUpLoad = false;
        this.scrollOptions.isNoMoreData = true;
      });
    },
    // 刷新列表数据
    refreshArticleInfo() {
      this.listReqOptions.pageNo = 1;
      this.getReporterInfoList(true);
    },
    /**
     * 订阅记者/取消订阅记者
     */
    async subscribeReporter() {
      let deviceId = await window.T.native.getDeviceIdFromValiVersionP();
      if (!deviceId) {
        utils.openNfApp(
          this.reporterInfo.reporterUuid,
          this.reporterInfo.reporterName
        );
        return;
      }
      let baseUrl = this.hasSubscribe
        ? "nanfang_if/reporter/cancelSubscribe"
        : "nanfang_if/reporter/subscribe";
      let params = {
        deviceId: deviceId,
        reporterUuid: this.reporterInfo.reporterUuid,
      };
      // let url = `${baseUrl}?deviceId=${deviceId}&reporterUuid=${
      //   this.reporterInfo.reporterUuid
      // }`
      if (this.userInfo.userUuid) {
        params.userUuid = this.userInfo.userUuid;
        // url += `&userUuid=${this.userInfo.userUuid}`
      }
      if (this.userInfo.userId) {
        params.userId = this.userInfo.userId;
        // url += `&userId=${this.userInfo.userId}`
      }
      this.showLoading = true;
      let headers = await window.T.native.getHttpHeaders();
      params = Object.assign(headers, params);
      http
        .get(baseUrl, params, null)
        .then((res) => {
          this.showLoading = false;
          if (res.data && res.code === 200) {
            let msg = this.hasSubscribe ? CANCEL_SUB_MSG : SUB_MSG;
            this.hasSubscribe = !this.hasSubscribe;
            this.setNativeSubStatus(this.hasSubscribe ? 1 : 0);
            this.showToast(msg);
          } else {
            this.showToast(res.msg);
          }
        })
        .catch((err) => {
          this.showLoading = false;
          window.console.warn(err);
          this.showToast(NET_ERR_MSG);
        });
    },
    // 根据订阅接口设置原生的订阅状态 subStatus - 1设置为已订阅，0设置为未订阅
    setNativeSubStatus(subStatus) {
      let options = {
        reporterUuid: this.reporterInfo.reporterUuid,
        subStatus: subStatus.toString(),
      };
      window.T.native.setNativeSubStatus(options);
    },
    // 关闭当前webview
    async jumpBack() {
      // this.showToast('正在退出...')
      // let timer = setTimeout(() => {
      //   clearTimeout(timer)
      //   timer = null
      //   window.T.native.closeWebView()
      // }, 3000)
      // await this.buryingPoint('', { dataType: '1000077', origin: '2' })
      window.T.native.closeWebView();
    },
    // 点击导航栏右上角分享
    handleShare() {
      let shareObj = {
        title: `${this.reporterInfo.reporterName}作品集-南方Plus`,
        content: `${this.reporterInfo.reporterName}，${this.reporterInfo.reporterDescribe}`,
        icon: this.reporterInfo.reporterPortraitUrl,
        url: `${config.openAppUrl}?reporterUuid=${this.reporterInfo.reporterUuid}&isOutside=1`,
        reporterUuid: this.reporterInfo.reporterUuid,
      };
      window.T.native.share(shareObj);
    },
    // 设置内容区padding
    setInfoWrapperPaddingTop() {
      if (this.os.android && !this.isOutSide) {
        this.InfoWrapperPaddingTop = utils.remToPx(1.68) - 20 + "px";
      } else {
        this.InfoWrapperPaddingTop = utils.remToPx(1.68) + "px";
      }
      if (this.isOutSide) {
        let navBarHeight = utils.remToPx(0.88);
        this.InfoWrapperPaddingTop =
          utils.remToPx(1.68) - navBarHeight - 20 + "px";
      }
      this.$nextTick(() => {
        this.refreshScroll();
      });
    },
    // 跳转到新闻详情页
    async toJumpDetail(item) {
      let isInside = await window.T.native.getDeviceIdFromValiVersionP();
      // 端内走协议， 端外走分享页
      if (isInside) {
        window.location.href = item.jumpUrl;
      } else {
        // 外链稿件类型，按照配置的链接进行打开，不做其他拼接处理
        if (item.articleType === 4) {
          window.location.href = item.shareUrl;
          return
        }
        const enterColumnId = utils.getParamsFromUrl().enterColumnId
        if (item.shareUrl.indexOf("?") > -1) {
          window.location.href = item.shareUrl + "&colID=" + item.colID + `${enterColumnId ? '&enterColumnId=' + enterColumnId : ''}`;
        } else {
          window.location.href = item.shareUrl + "?colID=" + item.colID + `${enterColumnId ? '&enterColumnId=' + enterColumnId : ''}`;
        }
      }
    },
    // 点击私信
    jumpToPrivateLetter() {
      if (this.userInfo.userUuid) {
        window.T.native.privateLetter({
          targetUserUuid: this.reporterInfo.reporterUserUuid,
          targetUserName: this.reporterInfo.reporterName,
          sourceUuid: this.userInfo.userUuid,
        });
      } else {
        this.showLoading = true;
        // 先判断是否登录
        window.T.native
          .getUserInfoP()
          .then((ret) => {
            this.showLoading = false;
            if (ret.userUuid) {
              window.T.native.privateLetter({
                targetUserUuid: this.reporterInfo.reporterUserUuid,
                targetUserName: this.reporterInfo.reporterName,
                sourceUuid: this.userInfo.userUuid,
              });
            } else {
              window.T.native.nativeLoginP().then((res) => {
                this.showLoading = false;
                this.userInfo.userUuid = res.userUuid;
                this.userInfo.phone = res.phone;
                this.userInfo.userId = res.userId || "";
                this.userInfo.reporterUuid = res.reporterUuid || "";
                this.getReporterSubStatus();
                // 判断当前登陆用户是否当前记者
                if (
                  this.userInfo.reporterUuid == this.reporterInfo.reporterUuid
                ) {
                  this.showToast("不可以和自己聊天喔");
                } else {
                  window.T.native.privateLetter({
                    targetUserUuid: this.reporterInfo.reporterUserUuid,
                    targetUserName: this.reporterInfo.reporterName,
                    sourceUuid: this.userInfo.userUuid,
                  });
                }
              });
            }
          })
          .catch(() => {
            this.showLoading = false;
            utils.openNfApp(
              this.reporterInfo.reporterUuid,
              this.reporterInfo.reporterName
            );
          });
      }
    },
    //点击私信，跳转h5私信
    jumpH5PrivateLetter() {
      // this.$router.push({
      //   path: "/privateLetter",
      //   query: {
      //     targetUserUuid: this.reporterInfo.reporterUserUuid,
      //     reporterName: this.reporterInfo.reporterName
      //   }
      // });
      if (this.userUuid) {
        this.$router.push({
          path: "/privateLetter",
          query: {
            targetUserUuid: this.reporterInfo.reporterUserUuid,
            reporterName: this.reporterInfo.reporterName,
          },
        });
      } else {
        //其他浏览器打开时，跳转客户端内
        utils.openNfApp(
          this.reporterInfo.reporterUuid,
          this.reporterInfo.reporterName
        );
      }
    },
    // 获取订阅状态
    getReporterSubStatus() {
      window.T.native
        .getReporterSubStatus({
          reporterUuid: this.reporterInfo.reporterUuid.toString(),
        })
        .then((ret) => {
          ret = parseInt(ret);
          this.hasSubscribe = ret === 1 ? true : false;
        })
        .catch(() => {
          this.hasSubscribe = false;
        });
    },
    // 获取用户信息
    getUserInfo() {
      return new Promise((resolve) => {
        window.T.native
          .getUserInfoP()
          .then((ret) => {
            if (ret && ret.userUuid) {
              this.userInfo.userUuid = ret.userUuid;
              this.userInfo.phone = ret.phone;
              this.userInfo.userId = ret.userId || "";
              this.userInfo.reporterUuid = ret.reporterUuid || "";
            }
            resolve(true);
          })
          .catch(() => {
            this.isOutSide = true;
            window.console.warn("没有获取到用户信息");
            resolve(false);
          });
      });
    },
    // 初始化微信分享
    initWxShare() {
      let _buryingPoint = this.buryingPoint;
      let shareOptions = {};
      shareOptions.title = `${this.reporterInfo.reporterName}作品集-南方Plus`;
      shareOptions.desc = `${this.reporterInfo.reporterName}，${this.reporterInfo.reporterDescribe}。`;
      shareOptions.link = `${config.openAppUrl}?reporterUuid=${this.reporterInfo.reporterUuid}&isOutside=1`;
      shareOptions.imgUrl = this.reporterInfo.reporterPortraitUrl;
      shareOptions.success = function () {
        // 进行埋点
        _buryingPoint(this.shareType);
      };
      utils.initWxShare(shareOptions);
      this.isInitWxShare = true;
    },
    exitBuryingPoint(){
      self._exitBuryingPoint = () => {
        this.sendExitBuryingPoint()
      }
      window.addEventListener('unload', self._exitBuryingPoint)
    },
    sendExitBuryingPoint(params) {
      try {
        const urlParams = getParamsFromUrl()
        navigator.sendBeacon(config.buryingPointUrl + 's', new Blob([JSON.stringify([{
          deviceid: utils.getDevicedId(),
          dataType: "1000077",
          reporterUuid: this.reporterInfo.reporterUuid || "",
          origin: (params && params.origin) || urlParams.origin || "1",
          itemId: urlParams.articleId || "",
          actionTime: Date.now()
        }])], {type: 'application/json'}))
      } catch (ex) {
        console.log(ex);
      }
    },
    // 分享埋点
    buryingPoint(shareType, params) {
      let buryingPointOptions = {
        deviceid: utils.getDevicedId(),
        dataType: "1000073",
        reporterUuid: this.reporterInfo.reporterUuid || "",
        origin: "2",
      };
      if (shareType) {
        buryingPointOptions.shareChanel = shareType;
      }
      Object.assign(buryingPointOptions, params);
      return new Promise((resolve) => {
        http
          .get(config.buryingPointUrl, buryingPointOptions)
          .then((res) => {
            window.console.log(res);
            window.console.log("埋点成功");
            resolve(true);
          })
          .catch((err) => {
            window.console.warn(err);
            window.console.warn("埋点失败");
            resolve(false);
          });
      });
    },
    // 进入页面埋点
    async enterPageBuryingPoint() {
      let deviceid = await window.T.native.getDeviceIdFromValiVersionP();
      if (!deviceid) {
        deviceid = utils.getDevicedId();
      }
      const urlParams = getParamsFromUrl()
      let params = {
        deviceid,
        dataType: "1000076",
        origin: urlParams.origin || "1",
        itemId: urlParams.articleId || ""
      };
      if (this.userInfo.userUuid) {
        params.userUuid = this.userInfo.userUuid;
      }
      if (this.userInfo.userId) {
        params.userId = this.userInfo.userId;
      }
      if (this.reporterInfo.reporterUserUuid) {
        params.reporterUserUuid = this.reporterInfo.reporterUserUuid;
      }
      window.console.log(params);
      this.buryingPoint("", params);
    },
    // 设置透明状态栏
    setTitleBarAttribute() {
      let params = {
        titleColor: "",
        title: "",
        titleBarColor: "",
        hiddenTitleBarLine: 0,
        headerStyleType: 2,
      };
      window.T.native.setTitleBarAttribute(params);
    },
    // 判断当前app版本是否兼容当前页面，当前页面要求app版本>=5.0
    isVerBefore500() {
      window.T.native
        .getInsideVersion()
        .then((res) => {
          this.insideVersion = res;
          res = parseInt(res);
          let isVerBefore500 = res && res < 500;
          if (isVerBefore500) {
            this.showUpdateTips = true;
          }
        })
        .catch((err) => {
          window.console.warn(err);
        });
    },
    // 显示完整简介
    handleShowAllDes() {
      this.showAllDes = true;
      this.$nextTick(() => {
        this.refreshScroll();
      });
    },
    // 判断是否需要显示展开
    needShowDeloy() {
      this.$nextTick(() => {
        var textEl = this.$refs.desc
        var spanEl = textEl.childNodes[0]
        var computedStyle = document.defaultView.getComputedStyle(textEl, null);
        var lineHeight = computedStyle.lineHeight;
        var top = 2 * parseInt(lineHeight);
        var originalStr = spanEl.innerText;
        var tempstr = originalStr;
        spanEl.innerText = tempstr;
        var len = tempstr.length;
        // offsetHeight大于两行的高度
        if (textEl.offsetHeight > top) {
          var temp = "";
          spanEl.innerText = temp;
          var i = 20; // 每行至少10个字符，所以从第20开始算
          while (textEl.offsetHeight <= top) {
            temp = tempstr.substring(0, i + 1);
            i++;
            spanEl.innerText = temp;
          }
          tempstr = temp.substring(0, temp.length - 1);
          len = tempstr.length;
          // 计算需要减少的字符个数，为“展开”计算位置
          var index = 0, charCount = 0, preIsNotCChar = 0;

          for (index = 0; index < 10; index++) {
            if (tempstr.charCodeAt(len - index - 1) > 255) {
              charCount++
            } else {
              preIsNotCChar++
              if (preIsNotCChar === 2) {
                preIsNotCChar = 0
                charCount++
              }
            }
            if (charCount === 4) {
              break;
            }
          }
          spanEl.innerText = tempstr.substring(0, len - (index + 1)) + "...";
        } else {
          return;
        }
        var more = document.createElement("span")
        more.style.cssText = `position: absolute;color: #666666;height: 0.36rem;line-height: 0.36rem;font-size: 0.26rem;right: 0px;bottom: 0px;`
        more.innerText = "展开"
        textEl.appendChild(more)
        var showed = false
        more.addEventListener("click", function click(event) {
          event.stopPropagation()
          if (!showed) {
            showed = true
            spanEl.innerHTML = originalStr;
            textEl.style.overflowY = "auto"
            more.removeEventListener("click", click)
            more.remove()
          } 
        }, true)
      });
    },
    async init() {
      this.setTitleBarAttribute();
      this.getSystemInfo();
      this.isVerBefore500();
      await this.getUserInfo();
      this.setInfoWrapperPaddingTop();
      this.getReporterNameFromUrl();
      this.getReporterSubStatus();
      this.refreshArticleInfo();
      // 5.4版本去掉这个埋点
      // 13.0版本打开
      this.enterPageBuryingPoint()
    },
    // 点击订阅跳转对应页面
    shareNFNum(id) {
      window.location.href = `${config.shareNFNum}?nfhId=${id}`;
    },
    addLaunchAppTag(){
      // 微信开放标签
      if(document.querySelector('.btn-subscribe')){
        let newParams = utils.getOpenAppParams(
          this.reporterInfo.reporterUuid,
          this.reporterInfo.reporterName
        );
        window.console.log('-- mountLaunchAppTag --')
        window.OpenApp.mountLaunchAppTag && window.OpenApp.mountLaunchAppTag(newParams, document.querySelector('.btn-subscribe'), process.env.VUE_APP_RUN_ENV === 'pro' ? '' : process.env.VUE_APP_RUN_ENV)
      }
    }
  },
  watch: {
    isInitWxShare: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.addLaunchAppTag()
          })
        }
      }
    }
  },
  computed: {
    // 屏幕顶部高度
    marginTop() {
      return this.os.android ? "0" : this.os.isPhoneX ? "44px" : "20px";
    },
    // 记者信息的backgroundPosition
    reportInfoBackgroundPos() {
      let posStr = "center ";
      let posY = 0;
      if (this.os.isPhoneX) {
        posY = -this.InfoWrapperPaddingTop.replace("px", "") - 24 + "px";
      } else {
        posY = "-" + this.InfoWrapperPaddingTop;
      }
      return posStr + posY;
    },
    // 是否为大屏手机
    isBigScreen() {
      return this.os.isLargeThan375;
    },
    // 是否为小屏手机
    isSmallScreen() {
      return this.os.isLessThan360;
    },
  },
  async mounted() {
    const userInfo = await window.nfWxAuth.getWxUserInfo({
      env,
      needSaveLocalStorage: true,
    });
    this.userUuid = userInfo.userUuid;
    this.exitBuryingPoint()
    // 确保dom渲染完成
    // setTimeout(() => {
    //   this.initData()
    // }, 20)
  },
  beforeRouteLeave(to, form, next){
    this.sendExitBuryingPoint({
      origin: form.query.origin
    })
    self._exitBuryingPoint && window.removeEventListener('unload', self._exitBuryingPoint)
    next()
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
  height: 100%;
  width: 100%;
  // background: url('./images/reporter_page_bg.png') no-repeat center top;
  // background-size: 100% auto;
  .top-bar {
    background: transparent;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 20px;
    transition: all 0.3s;
    background: url("./images/reporter_page_bg.png") no-repeat center top;
    background-size: 100% auto;
  }
  .top-bar,
  .header-wrapper {
    z-index: 9999;
  }
  .header-wrapper {
    position: fixed;
    top: 20px;
    left: 0;
    width: 100%;
    height: 0.88rem;
    overflow: hidden;
    background: url("./images/reporter_page_bg.png") no-repeat;
    background-size: 100% auto;
    .header-relative {
      position: relative;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      .header {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 0.88rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.3rem;
        background: transparent;
        color: #ffffff;
        font-family: PingFangSC-Semibold;
        font-size: 0.36rem;
        .more-wrapper {
          min-width: 1.8rem;
          display: flex;
          flex-direction: row-reverse;
          height: 100%;
          align-items: center;
        }
        .btn {
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 0.08rem;
          width: 1rem;
          height: 0.5rem;
          color: #ffffff;
          background-color: rgba(255, 255, 255, 0);
          font-size: 0.24rem;
          line-height: 0.4rem;
          font-family: PingFangSC-Regular;
          outline: none;
          margin-right: 0.3rem;
          &.btn-opacity {
            &:active {
              background-color: rgba(255, 255, 255, 0.2);
              color: rgba(255, 255, 255, 0.8);
            }
          }
          &.btn-bg {
            background-color: #f64e45;
            border: none;
            &:active {
              opacity: 0.7;
            }
          }
          &.bg-gray {
            background-color: #aaaaaa;
          }
        }
        &.active {
          .title {
            opacity: 1;
          }
        }
        .title {
          opacity: 0;
          transition: all 0.3s;
          color: #ffffff;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          max-width: 3rem;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .iconfont,
        .icon {
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          font-size: 0.4rem;
          line-height: 0.4rem;
        }
        .icon.icon-point {
          background: url("./images/nav_icon_dot_white.png") no-repeat center;
          background-size: 100% auto;
        }
      }
    }
  }
  .bg-wrapper {
    background: #310303 url("./images/reporter_page_bg.png") no-repeat center
      top;
    background-size: 100% auto;
    height: 35%;
    width: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    min-height: 4rem;
  }

  .info-wrapper {
    position: relative;
    z-index: 1;
    width: 100%;
    .reporter-info-wrap {
      // background: url('./images/reporter_page_bg.png') no-repeat center top;
      background-size: 100% auto;
      // padding-top: 20px;
      .reporter-name {
        width: 100%;
        padding-left: 2rem;
        padding-right: 0.4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
        .name {
          color: #ffffff;
          font-size: 0.36rem;
          font-family: PingFangSC-Semibold;
          line-height: 0.5rem;
          flex: 1;
          white-space: pre-wrap;
          word-break: break-all;
          margin-right: 0.2rem;
        }
        .btn-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row-reverse;
          width: 2.3rem;
          .btn {
            border: 1px solid rgba(255, 255, 255, 0.5);
            border-radius: 0.08rem;
            width: 1rem;
            height: 0.5rem;
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0);
            font-size: 0.24rem;
            line-height: 0.5rem;
            font-family: PingFangSC-Regular;
            outline: none;
            text-align: center;
            &.btn-opacity {
              &:active {
                background-color: rgba(255, 255, 255, 0.2);
                color: rgba(255, 255, 255, 0.8);
              }
            }
            &.btn-bg {
              background-color: #f64e45;
              border: none;
              &:active {
                opacity: 0.7;
              }
            }
            &.bg-gray {
              background-color: #aaaaaa;
            }
          }
        }
      }
      .reporter-intruduce {
        width: 100%;
        padding: 0.7rem 0.6rem 0.2rem 0.6rem;
        background: #ffffff;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #999999;
        line-height: 0.36rem;
        position: relative;
        border-top-left-radius: 0.2rem;
        border-top-right-radius: 0.2rem;
        .item {
          margin-bottom: 0.1rem;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          &.center {
            align-items: center;
          }

          &:nth-child(2) {
            margin-bottom: 0.18rem;
          }

          .title {
            display: inline-block;
            width: 1.1rem;
            flex: none;
          }
          .des-wrapper {
            flex: 1;
            height: auto;
            .short-des {
              height: auto;
              overflow: hidden;
              width: 100%;
              position: relative;
              min-height: 0.36rem;
              .info {
                text-align: justify;
                &.top {
                  height: 0.36rem;
                  overflow: hidden;
                  background: #ffffff;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 10;
                }
                &.bottom {
                  width: 100%;
                  position: relative;
                  transform: translate3d(-0.78rem, 0, 0);
                  text-indent: 0.78rem;
                  background: #ffffff;
                  z-index: 1;
                  &.big-screen {
                    transform: translate3d(-0.77rem, 0, 0);
                  }
                }
                &.standard {
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: -9999;
                  opacity: 0;
                }
                // &.small-screen {
                //   text-indent: 1.6em;
                //   transform: translate3d(-1.82em, 0, 0);
                // }
              }
              .btn {
                position: absolute;
                top: 0.36rem;
                right: 0;
                z-index: 20;
                background: #ffffff;
                border: none;
                outline: none;
                display: block;
                height: 0.36rem;
                line-height: 0.36rem;
                font-family: PingFangSC-Regular;
                font-size: 0.26rem;
                color: #666666;
              }
            }
          }
          .info {
            flex: 1;
            white-space: normal;
            word-break: break-all;
            display: -webkit-box;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-align: left;
            text-overflow: ellipsis;

            &.no-limit {
              display: block;
              -webkit-box-orient: none;
              -webkit-line-clamp: none;
              position: relative;
            }
            
          }
          // 运营信息
          .operate-info {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            .left {
              display: flex;
              align-items: center;
              flex: 1;

              img {
                width: 0.4rem;
                height: 0.4rem;
                margin-right: 0.1rem;
                border-radius: 50%;
              }
              p {
                width: 4rem;
                color: rgba(75, 143, 235, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .more {
              display: flex;
              align-items: center;
              min-width: fit-content;
              .icon_next_grey {
                width: 0.32rem;
                height: 0.32rem;
                margin-top: -0.05rem;
                margin-right: -0.1rem;
                background: url("./images/icon_next_grey.png") no-repeat center;
                background-size: 100% auto;
              }
            }
          }
        }
        .reporter-header-wrapper {
          position: absolute;
          top: -0.76rem;
          left: 0.6rem;
          width: 1.2rem;
          height: 1.2rem;
          border: 2px solid #ffffff;
          border-radius: 50%;
          background: #ffffff;
          .reporter-header {
            border-radius: 50%;
            overflow: hidden;
            width: 100%;
            height: 100%;
            .img-response {
              width: 1.2rem;
              height: 1.2rem;
              -o-object-fit: contain;
              object-fit: contain;
            }
          }
          .icon-v {
            height: 0.44rem;
            width: 0.44rem;
            background: url("./images/icon_reporter_v.png") no-repeat center;
            background-size: 100% auto;
            position: absolute;
            bottom: 0;
            right: -0.04rem;
          }
        }
      }
    }
    .middle-slit {
      height: 0.1rem;
      width: 100%;
      background: #f7f7f7;
    }
    .reporter-works-list {
      .reporter-works-item {
        background: #ffffff;
        &:active {
          background: #f0f0f0;
        }
      }
    }
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to,
  .fade-leave {
    opacity: 1;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s;
  }

  .drop-top-enter,
  .drop-top-leave-to {
    opacity: 0;
    // transform: translate3d(0, 120%, 0);
  }
  .drop-top-enter-to,
  .drop-top-leave {
    opacity: 1;
    // transform: translate3d(0, 0, 0);
  }
  .drop-top-enter-active,
  .drop-top-leave-active {
    transition: all 0.3s;
  }
}
</style>
